<!-- 投顾报告-->
<template>
  <div class="tougubaogao-layer">
    <div class="tougubaogao-download">
      <button class="generate-report-btn" @click="downloadReport">下载报告</button>
    </div>
    <div class="tougubaogao-container" ref="reportContainer"></div>
  </div>
</template>

<script>
// 导入PDF生成工具
import printPDF from '@/utils/printPDF.js'

export default {
  name: 'TouguBaogao',
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    // 模拟报告内容 - 实际项目中这部分内容应该是从API获取的
    if (this.$refs.reportContainer) {
      this.$refs.reportContainer.innerHTML = `
        <div style="padding: 40px; font-family: Arial, sans-serif; color: #fff;">
          <h1 style="text-align: center; color: #fff; margin-bottom: 30px;">个人投资顾问报告</h1>
          
          <div style="margin-bottom: 30px;">
            <h2 style="color: #fff; border-bottom: 1px solid #ddd; padding-bottom: 10px;">投资概要</h2>
            <p style="line-height: 1.6;">根据您的风险偏好和投资目标，我们为您制定了以下投资组合方案。</p>
            <p style="line-height: 1.6;">本次投资组合类型：<strong>R1 保守型</strong></p>
            <p style="line-height: 1.6;">投资金额：<strong>2,000,000元</strong></p>
            <p style="line-height: 1.6;">投资期限：<strong>24个月</strong></p>
          </div>
          
          <div style="margin-bottom: 30px;">
            <h2 style="color: #fff; border-bottom: 1px solid #ddd; padding-bottom: 10px;">资产配置明细</h2>
            <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
              <thead>
                <tr style="">
                  <th style="border: 1px solid #ddd; padding: 10px; text-align: left;">产品名称</th>
                  <th style="border: 1px solid #ddd; padding: 10px; text-align: right;">年化收益率</th>
                  <th style="border: 1px solid #ddd; padding: 10px; text-align: right;">配置比例</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 10px;">天弘余额宝货币基金</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">2.5%</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">20%</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 10px;">招商招钱宝货币A</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">2.5%</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">30%</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 10px;">易方达增强回报债券A</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">4.2%</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">20%</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 10px;">南方元宝债券A</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">4.0%</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">20%</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 10px;">华夏沪深300ETF联接A</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">6.5%</td>
                  <td style="border: 1px solid #ddd; padding: 10px; text-align: right;">10%</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div style="margin-bottom: 30px;">
            <h2 style="color: #fff; border-bottom: 1px solid #ddd; padding-bottom: 10px;">投资风险提示</h2>
            <ul style="line-height: 1.6; margin-left: 20px;">
              <li>本报告仅供参考，不构成任何投资建议</li>
              <li>投资有风险，入市需谨慎</li>
              <li>过往业绩不代表未来表现</li>
              <li>请根据自身风险承受能力选择合适的投资产品</li>
            </ul>
          </div>
          
          <div style="margin-top: 50px; text-align: right; color: #666;">
            <p>报告生成时间：${new Date().toLocaleString()}</p>
            <p>© 2025 AI金融智能投研系统</p>
          </div>
        </div>
      `
    }
  },
  methods: {
    downloadReport () {
      if (this.$refs.reportContainer) {
        // 使用printPDF工具将报告容器转换为PDF并下载
        printPDF(this.$refs.reportContainer, '投顾报告')
          .then(() => {
            // 可以在这里添加下载成功的提示
            console.log('PDF下载成功')
          })
          .catch((error) => {
            // 处理下载失败的情况
            console.error('PDF下载失败:', error)
            alert('报告下载失败，请稍后重试')
          })
      } else {
        console.error('报告容器不存在')
        alert('报告内容不存在，请刷新页面后重试')
      }
    }
  }
}
</script>

<style scoped lang="less">
.tougubaogao-layer {
  height: 100%;
  position: relative;

  .tougubaogao-download {
    position: absolute;
    top: 10px;
    right: 10px;

    .generate-report-btn {
      padding: 12px 40px;
      font-size: 16px;
      font-weight: bold;
      background: #1549F3;
      color: #fff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
      align-self: center;
    }

    .generate-report-btn:hover {
      background: #1549F3;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(21, 73, 243, 0.5);
    }

    .generate-report-btn:active {
      transform: translateY(0);
    }
  }

  .tougubaogao-container {
    height: 100%;
    // background: white;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
